import { useCallback } from "react";
import { POST_TYPES } from "@infrastructure/Services/PostService.types";
import { Post as GameTimelinePost } from "../../../Presentation/Components/GameTimelinePost/Post";
import { Post } from "../../../Presentation/Components/Post/Post";
import { PostType } from "../../../Presentation/Components/Post/Post.types";
import { isPlatformTrucktour } from "@infrastructure/Services/EnvService";
import { TruckPost } from "../../../Presentation/Pages/TruckTourFeedPage/Components/Post/TruckPost";

export const usePostComponentFactory = () => {
    const factory = useCallback((post: PostType) => {
        if (isPlatformTrucktour) {
            return TruckPost;
        }
        switch (post.postData.type) {
            case POST_TYPES.TIPP_GAME:
                return GameTimelinePost;
            default:
                return Post;
        }
    }, []);
    return { factory };
};
